<div class="sidebar-modern d-flex bg-white shadow border-top"
 :class="{ collapsed: is_collapsed, 'drive-route-collapsed': is_drive_route }">
  <!-- Collapse Toggle Button -->
  <button 
    class="collapse-toggle position-fixed align-items-center shadow bg-white border border-secondary rounded-end"
    @click.stop="toggle_collapse" 
    @mousedown.prevent
    type="button"
    aria-label="Toggle sidebar"
  >
    <div :class="{ 'rotated': settings_menu_open }">
      <img :src="require('@/assets/sidebar_toggle.svg')">
    </div>
  </button>

  <!-- Logo Section -->
  <div class="sidebar-header">
    <div class="logo-container d-flex">
      <img :src="get_sidebar_logo_src()" alt="AIC ONE" class="main-logo">
    </div>
  </div>

  <!-- App Launcher -->
  <div class="app-launcher-section">
    <div class="dropdown">
      <button 
        class="app-launcher-btn d-flex"
        data-tooltip="My Apps"
        type="button" 
        id="app_launcher_btn" 
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <img :src="styleConfig.app_vector" alt="platforms" class="launcher-icon">
        <span class="launcher-text">My Apps</span>
      </button>

      <div class="dropdown-menu app-grid-dropdown bg-white" aria-labelledby="app_launcher_btn">
        <div class="app-grid bg-white">
          <a v-if="allowed_app_keys.includes('orcaa')" class="app-item d-flex" @click="launch_platform('orcaa')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/orcaa_ai.svg')" alt="Orcaa">
            </div>
          </a>

          <a v-if="allowed_app_keys.includes('workflow')" class="app-item d-flex" @click="launch_platform('workflow')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/proba-workflows.svg')" alt="Workflows">
            </div>
          </a>

          <a v-if="allowed_app_keys.includes('complyon')" class="app-item d-flex" @click="launch_platform('complyon')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/complyon.svg')" alt="Complyon">
            </div>
          </a>
          <a v-if="allowed_app_keys.includes('engagenet')" class="app-item d-flex" @click="launch_platform('engagenet')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/engagenet.svg')"
                :alt="is_internal_suite ? 'IC Workbook' : 'Engagenet'">
            </div>
          </a>

          <a v-if="allowed_app_keys.includes('x-verdict')" class="app-item d-flex" @click="launch_platform('x-verdict')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/x-verdict.svg')" alt="X-Verdict">
            </div>
          </a>

          <a v-if="allowed_app_keys.includes('proba')" class="app-item d-flex" @click="launch_platform('proba')">
            <div class="app-icon-wrapper d-flex">
              <img :src="require('@/assets/platforms_icons/proba-analytics.svg')" alt="Analytics">
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="sidebar-scroll-area">
    <!-- Main Navigation -->
    <nav class="sidebar-nav position-relative" aria-label="Primary navigation">
      <router-link to="/home" class="nav-item d-flex" active-class="active" data-tooltip="Home">
        <div class="nav-icon d-flex">
          <img :src="require('@/assets/home.svg')" class="svg-icon" alt="Home">
        </div>
        <span class="nav-label">Home</span>
      </router-link>

    <router-link to="/ziva" class="nav-item d-flex" active-class="active" data-tooltip="Ziva Assistant">
      <div class="nav-icon d-flex">
        <img :src="require('@/assets/onechat_Icon.svg')" alt="Ziva Assistant">
      </div>
      <span class="nav-label">Ziva Assistant</span>
    </router-link>

    <router-link to="/create" class="nav-item d-flex" active-class="active" data-tooltip="Projects & Workspaces">
      <div class="nav-icon d-flex">
        <img :src="styleConfig.workspace_vector_sidebar" alt="Create">
      </div>
      <span class="nav-label">Projects & Workspaces</span>
    </router-link>

    <router-link to="/drive" class="nav-item d-flex" active-class="active" data-tooltip="Documents & Storage">
      <div class="nav-icon d-flex">
        <img :src="require('@/assets/award.svg')" alt="AIC Drive">
      </div>
      <span class="nav-label">Documents & Storage</span>
    </router-link>

    <router-link to="/audit_trail" class="nav-item d-flex" active-class="active" data-tooltip="Governance & Security">
      <div class="nav-icon d-flex">
        <img :src="styleConfig.audit_vector_sidebar" alt="Audit Trail">
      </div>
      <span class="nav-label">Governance & Security</span>
    </router-link>

    <router-link to="/support" class="nav-item d-flex d-none" active-class="active" data-tooltip="Support & Community">
      <div class="nav-icon d-flex">
        <img :src="require('@/assets/safearea.svg')" alt="Audit Trail">
      </div>
      <span class="nav-label">Support & Community</span>
    </router-link>

    <!-- Settings with Expandable Submenu -->
    <div v-if="is_admin" class="nav-item-wrapper w-100">
      <button
        class="nav-item settings-menu-toggle d-flex flex-column align-items-center justify-content-center position-relative w-100 border-0 bg-transparent"
        data-tooltip="Settings"
        :class="{ active: settings_menu_open }"
        @click="toggle_settings_menu"
        type="button"
        :aria-expanded="settings_menu_open ? 'true' : 'false'"
        aria-controls="admin_settings_submenu"
      >
        <div class="nav-icon d-flex align-items-center justify-content-center">
          <img :src="styleConfig.settings_vector_sidebar" alt="Settings">
        </div>
        <span class="nav-label">
          Settings
        </span>
        <i
          class="submenu-arrow fas fa-chevron-down position-absolute d-inline-flex align-items-center justify-content-center"
          :class="{ 'rotate-180': settings_menu_open }"
          aria-hidden="true"
        ></i>
      </button>

      <div
        id="admin_settings_submenu"
        class="nav-submenu"
        :class="{ 'open': settings_menu_open }"
      >
        <router-link
          to="/profile" 
          class="submenu-item d-flex" 
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <img :src="styleConfig.profile_vector_sidebar" alt="Profile">
          </div>
          <span class="nav-label submenu-label-mobile">Profile</span>
        </router-link>

        <router-link
          to="/permission"
          class="submenu-item d-flex"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <img :src="styleConfig.permissions_vector_sidebar" alt="Permissions">
          </div>
          <span class="nav-label submenu-label-mobile">Permissions</span>
        </router-link>

        <router-link
          to="/role"
          class="submenu-item d-flex"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <img :src="styleConfig.workspace_vector_sidebar" alt="Roles">
          </div>
          <span class="nav-label submenu-label-mobile">Roles</span>
        </router-link>

        <router-link
          to="/settings"
          class="submenu-item d-flex"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <img :src="styleConfig.users_vector_sidebar" alt="Users">
          </div>
          <span class="nav-label submenu-label-mobile">Users</span>
        </router-link>

        <router-link
          to="/access_control"
          class="submenu-item d-flex d-none"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <img :src="require('@/assets/user.svg')" alt="Access Control">
          </div>
          <span class="nav-label submenu-label-mobile">Access Control</span>
        </router-link>

        <router-link
          to="/system_configure"
          class="submenu-item d-flex "
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <img :src="styleConfig.settings_vector_sidebar" alt="System Configure">
          </div>
          <span class="nav-label submenu-label-mobile">System Configure</span>
        </router-link>

        <router-link
          to="/platform_management"
          class="submenu-item d-flex d-none"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="d-flex launcher-icon" >
            <img :src="styleConfig.app_vector" alt="Platform Management">
          </div>
          <span class="nav-label submenu-label-mobile">Platform Management</span>
        </router-link>

        <router-link
          to="/superset_manager"
          class="submenu-item d-flex d-none"
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <img :src="require('@/assets/user.svg')" alt="Superset">
          </div>
          <span class="nav-label submenu-label-mobile">Manage Superset</span>
        </router-link>

        <router-link
          to="/main_settings"
          class="submenu-item d-flex "
          active-class="active"
          @click.native="close_settings_menu_on_mobile"
        >
          <div class="submenu-icon d-flex">
            <img :src="styleConfig.settings_vector_sidebar" alt="Settings">
          </div>
          <span class="nav-label submenu-label-mobile">General Settings</span>
        </router-link>

      </div>

      <div
        v-if="settings_menu_open"
        class="submenu-overlay d-block d-sm-none"
        @click="close_settings_menu_on_mobile"
      ></div>
    </div>
    </nav>

    <!-- Logout Section -->
    <div v-if="should_show_logout" class="sidebar-footer">
      <button class="logout-btn d-flex" data-tooltip="Logout" @click="logout()">
        <div class="nav-icon">
          <img :src="require('@/assets/logout.svg')" alt="Logout">
        </div>
        <span class="nav-label">Logout</span>
      </button>
    </div>
  </div>
</div>
